/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {

    connectedCallback() {
      this.ticking = false;
      this._onScroll = this.checkVisible.bind(this);
      this._onResize = () => {
        this.pageHeight = window.innerHeight;
        this.positionAboveChat();
      };

      this.pageHeight = window.innerHeight;
      this.chatGap = 12;
      this.chatResizeObserver = null;
      this.chatPositionTimers = [];

      this.addEventListener('click', this.onClick);
      this.addEventListener('touchstart', this.onClick, { passive: true });
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });

      this.watchChatActivator();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      if (this.chatResizeObserver) this.chatResizeObserver.disconnect();
      this.chatPositionTimers.forEach((timer) => window.clearTimeout(timer));
    }

    getChatActivator() {
      const chat = document.querySelector('shopify-chat');
      return chat?.shadowRoot?.querySelector('[part="activator"]') || null;
    }

    positionAboveChat(pass = 0) {
      const activator = this.getChatActivator();

      if (!activator) {
        this.style.removeProperty('bottom');
        return false;
      }

      const activatorRect = activator.getBoundingClientRect();

      if (activatorRect.width === 0 || activatorRect.height === 0) return false;

      // The activator already reflects its responsive safe-area and sticky-cart
      // offsets. Correct from the button's rendered position, not a fixed screen value.
      const desiredBottomEdge = activatorRect.top - this.chatGap;
      const currentRect = this.getBoundingClientRect();
      const currentBottom = parseFloat(window.getComputedStyle(this).bottom) || 0;
      const adjustment = currentRect.bottom - desiredBottomEdge;

      if (Math.abs(adjustment) > 0.5) {
        this.style.setProperty('bottom', `${Math.max(0, Math.ceil(currentBottom + adjustment))}px`);

        // Some theme transforms affect the rendered position. A few animation-frame
        // corrections settle the real visual position without polling the DOM.
        if (pass < 3) {
          window.requestAnimationFrame(() => this.positionAboveChat(pass + 1));
        }
      }

      return true;
    }

    watchChatActivator() {
      const bindActivator = () => {
        const activator = this.getChatActivator();

        if (!activator) return false;

        this.positionAboveChat();

        if (window.ResizeObserver) {
          this.chatResizeObserver?.disconnect();
          this.chatResizeObserver = new ResizeObserver(() => this.positionAboveChat());
          this.chatResizeObserver.observe(activator);
        }

        return true;
      };

      [0, 250, 1000, 2500, 5000].forEach((delay) => {
        const timer = window.setTimeout(bindActivator, delay);
        this.chatPositionTimers.push(timer);
      });
    }

    checkVisible() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.classList.toggle('back-to-top--active', window.scrollY > this.pageHeight);
        this.ticking = false;
      });
    }

    onClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
  customElements.define('back-to-top', BackToTop);
}
